<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('settlement_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="settlement_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('sale_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="sale_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('first_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="first_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('last_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="last_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('company_name')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="company_name"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('client_tier')">
              <client-tier-select-input-widget :model="searchModel" attribute="client_tier" :label="false"
                                               :options="{placeholder: $t('Client Tier')}"/>
            </div>
            <div class="input-wrapper">
              <b-form-group class="">
                <date-range-picker
                  class="d-flex w-100"
                  @update="onDateRangeApply"
                  showWeekNumbers
                  showDropdowns
                  ref="picker"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  v-model="dateRange">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Date Range') }}
                    </span>
                    <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>
            <div class="input-wrapper">
              <customer-select-input-widget @select="onCustomerSelect"
                                            v-if="!excludeSearchFields.includes('customer_uuid')"
                                            :model="searchModel"
                                            :label="false"
                                            :options="{placeholder: $t('Customer')}"
                                            attribute="customer_uuid"
                                            is-search/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('status')">
              <input-widget
                  :model="searchModel" attribute="status" type="select2" :items="statuses" value-field="key"
                  :label="false" :options="{placeholder: $t('Status')}" display-field="${item.text}"
                  multiple>
              </input-widget>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('type')">
              <input-widget
                  :model="searchModel" attribute="type" type="select2" :items="settlementTypes"
                  value-field="value" :label="false"
                  :options="{placeholder: $t('Type')}" display-field="${item.key}">
              </input-widget>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('receipt_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="receipt_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('lot_no')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="lot_no"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('vendor_payment_method')">
                <input-widget :model="searchModel" attribute="vendor_payment_method" type="select2" :items="vendorPaymentMethods"
                              value-field="value" :label="false" :options="{placeholder: $t('Vendor Payment Method')}"
                              display-field="${item.key}">
                </input-widget>
            </div>

            <template v-if="enableAccountingExport">
              <div class="input-wrapper">
                <b-form-group class="">
                  <date-range-picker
                    class="d-flex w-100"
                    @update="onSalesDateRangeApply"
                    showWeekNumbers
                    showDropdowns
                    ref="picker"
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                    v-model="salesDateRange">
                    <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Sales Date Range') }}
                    </span>
                      <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                    </template>
                  </date-range-picker>
                </b-form-group>
              </div>
              <div class="input-wrapper">
                <b-form-group class="">
                  <date-range-picker
                    class="d-flex w-100"
                    @update="onPaymentsDateRangeApply"
                    showWeekNumbers
                    showDropdowns
                    ref="picker"
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                    v-model="paymentsDateRange">
                    <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Payments Date') }}
                    </span>
                      <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                    </template>
                  </date-range-picker>
                </b-form-group>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('approved')">
                <input-widget
                  :model="searchModel" attribute="approved" type="select2" :items="approvalChoices"
                  :label="false" value-field="key" :options="{placeholder: $t('Approved')}"
                  display-field="${item.text}">
                </input-widget>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('payment_method')">
                <input-widget :model="searchModel" attribute="payment_method" type="select2" :items="vendorPaymentMethods"
                              value-field="value" :label="false" :options="{placeholder: $t('Payment Method')}"
                              display-field="${item.key}">
                </input-widget>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('export_id_min')">
                <input-widget :label="false" :disabled="isFieldExportDisabled" :placeholder="true" :model="searchModel" attribute="export_id_min"/>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('export_id_max')">
                <input-widget :label="false" :disabled="isFieldExportDisabled" :placeholder="true" :model="searchModel" attribute="export_id_max"/>
              </div>
            </template>

            <div class="input-wrapper" v-if="!excludeSearchFields.includes('settlement_notification_sent')">
              <input-widget :placeholder="true" :model="searchModel"
                            attribute="settlement_notification_sent" type="checkbox"/>
            </div>
            <div v-if="dynamicFieldsFilters.length > 0">
              <div class="input-wrapper" v-for="field in dynamicFieldsFilters" :key="field.key">
                <input-widget :label="false" :placeholder="field.label" :model="searchModel" :attribute="field.key"/>
              </div>
            </div>
            <template v-if="enableAccountingExport">
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('is_not_exported')">
                <input-widget type="checkbox" :disabled="isCheckboxExportDisabled('is_not_exported')" :model="searchModel" attribute="is_not_exported"/>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('is_previously_exported')">
                <input-widget type="checkbox" :disabled="isCheckboxExportDisabled('is_previously_exported')" :model="searchModel" attribute="is_previously_exported"/>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('is_payments_not_exported')">
                <input-widget type="checkbox" :disabled="isCheckboxExportDisabled('is_payments_not_exported')" :model="searchModel" attribute="is_payments_not_exported"/>
              </div>
              <div class="input-wrapper" v-if="!excludeSearchFields.includes('is_payments_previously_exported')">
                <input-widget type="checkbox" :disabled="isCheckboxExportDisabled('is_payments_previously_exported')" :model="searchModel" attribute="is_payments_previously_exported"/>
              </div>
            </template>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('identity_verification')">
              <input-widget :model="searchModel" :label="false" :options="{placeholder: $t('Identity Verification')}"
                            display-field="${item.key}" attribute="identity_verification" type="select2" value-field="value"
                            :items="identityVerificationTypes"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('kyc_status_verification')">
               <input-widget :model="searchModel" :label="false" :options="{placeholder: $t('Account/KYC Verification')}"
                            display-field="${item.key}" attribute="kyc_status_verification" type="select2" value-field="value"
                            :items="kycVerificationTypes"/>
            </div>
            <div class="input-wrapper" v-if="branches.rows.length > 1">
              <input-widget type="select2" :model="searchModel" attribute="branch_uuids" :label="false" multiple
                 :options="{placeholder: $t('Branch')}" :items="branches.rows" value-field="uuid"
                 display-field="${item.name}"/>
            </div>
            <div class="input-wrapper" v-if="vendorBuyerGroupAccountsEnabled">
              <input-widget :model="searchModel" attribute="vendor_group_account" :label="false" :placeholder="true"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import CustomerSelectInputWidget from "../../core/widgets/CustomerSelectInputWidget";
  import i18n from "../../shared/i18n";
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import ClientTierSelectInputWidget from "@/core/widgets/ClientTierSelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('settlements');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');

  export default {
    name: "SettlementSearch",
    components: {ClientTierSelectInputWidget, CustomerSelectInputWidget, InputWidget, DateRangePicker,},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        statuses: [
          {key: 'paid', text: i18n.t('Paid')},
          {key: 'unpaid', text: i18n.t('Unpaid')},
          {key: 'cancelled', text: i18n.t('Cancelled')},
          {key: 'debited', text: i18n.t('Debited')}
        ],
        dateRange: {startDate: null, endDate: null},
        salesDateRange: {startDate: null, endDate: null},
        paymentsDateRange: {startDate: null, endDate: null},
        approvalChoices: [
          {key: 'true', text: i18n.t('Approved')},
          {key: 'false', text: i18n.t('Not Approved')},
        ],
      }
    },
    watch: {
      "isFieldExportDisabled" (_, newValue) {
        if(!newValue) {
          this.searchModel.export_id_min = null
          this.searchModel.export_id_max = null
        }
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
      ...mapStateBranch(['branches']),
      ...mapStateGlobal({
        vendorPaymentMethods: state => state.paymentMethods.filter(item => item.value !== 'deposit'),
        dynamicFieldsFilters: (state) => {
          let result = [];
          if (state.dynamicFieldsFilters && state.dynamicFieldsFilters.settlements) {
            result = state.dynamicFieldsFilters.settlements;
          }
          return result;
        },
        enableAccountingExport: state => state.enableAccountingExport,
        vendorBuyerGroupAccountsEnabled: state => state.vendorBuyerGroupAccountsEnabled,
        settlementTypes: state => state.settlementTypes,
        identityVerificationTypes: state => state.identityVerificationTypes,
        kycVerificationTypes: state => state.kycVerificationTypes,
      }),
      isFieldExportDisabled() {
        const {
          is_previously_exported,
          is_payments_previously_exported
        } = this.searchModel
        return !(is_previously_exported || is_payments_previously_exported)
      },
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel({searchModel: this.searchModel});
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.dateRange = {startDate: null, endDate: null};
        this.salesDateRange = {startDate: null, endDate: null};
        this.paymentsDateRange = {startDate: null, endDate: null};
        this.resetTable();
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({searchModel: {customer}});
      },
      onDateRangeApply() {
        this.searchModel.dateRange = this.dateRange;
      },
      onSalesDateRangeApply() {
        this.searchModel.salesDateRange = this.salesDateRange;
      },
      onPaymentsDateRangeApply() {
        this.searchModel.paymentsDateRange = this.paymentsDateRange;
      },
      isCheckboxExportDisabled(key) {
        const {
          is_not_exported,
          is_previously_exported,
          is_payments_not_exported,
          is_payments_previously_exported
        } = this.searchModel

        if (is_not_exported || is_previously_exported || is_payments_not_exported || is_payments_previously_exported) {
          return !this.searchModel[key]
        }
        return false
      }
    },
    mounted() {
      if (this.searchModel && this.searchModel.dateRange) {
        this.dateRange = this.searchModel.dateRange;
      }
      if (this.searchModel && this.searchModel.salesDateRange) {
        this.salesDateRange = this.searchModel.salesDateRange;
      }
      if (this.searchModel && this.searchModel.paymentsDateRange) {
        this.paymentsDateRange = this.searchModel.paymentsDateRange;
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
